import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const KeyboardTabLine = ({ width = 18, height = 18, fill = '#4C5053', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5623 13.3125C15.4028 13.3125 15.2693 13.2586 15.1616 13.1507C15.0539 13.0429 15 12.9094 15 12.75V5.25C15 5.09063 15.0539 4.95706 15.1618 4.84931C15.2697 4.74144 15.4033 4.6875 15.5627 4.6875C15.7222 4.6875 15.8558 4.74144 15.9634 4.84931C16.0711 4.95706 16.125 5.09063 16.125 5.25V12.75C16.125 12.9094 16.0711 13.0429 15.9632 13.1507C15.8553 13.2586 15.7217 13.3125 15.5623 13.3125ZM11.2082 9.5625H2.4375C2.27813 9.5625 2.14456 9.50856 2.03681 9.40069C1.92894 9.29281 1.875 9.15919 1.875 8.99981C1.875 8.84031 1.92894 8.70675 2.03681 8.59913C2.14456 8.49138 2.27813 8.4375 2.4375 8.4375H11.2011L8.72738 5.93794C8.62363 5.83406 8.571 5.70669 8.5695 5.55581C8.568 5.40481 8.62306 5.27312 8.73469 5.16075C8.83694 5.05775 8.96706 5.00625 9.12506 5.00625C9.28306 5.00625 9.414 5.05819 9.51788 5.16206L12.8813 8.52544C12.9514 8.59569 13.0009 8.67006 13.0298 8.74856C13.0586 8.82706 13.0731 8.91119 13.0731 9.00094C13.0731 9.09069 13.0586 9.1745 13.0298 9.25238C13.0009 9.33025 12.9514 9.40431 12.8813 9.47456L9.51056 12.8453C9.40794 12.949 9.27963 13.0009 9.12563 13.0009C8.97175 13.0009 8.839 12.949 8.72738 12.8453C8.61113 12.7336 8.55419 12.5999 8.55656 12.4442C8.55894 12.2884 8.61588 12.1548 8.72738 12.0433L11.2082 9.5625Z"
        fill={fill}
      />
    </Svg>
  );
};

export default KeyboardTabLine;
